import { useSelector } from 'react-redux';
import { ApplicationState, WithAccountId } from '@mews-commander/types';
import { getCustomerOrCompanyFullName } from '@mews-commander/legacy-entities/src/ducks/customers';

export const AccountFullName = ({ accountId }: WithAccountId) => {
    const fullName = useSelector((state: ApplicationState) => getCustomerOrCompanyFullName(state, { id: accountId }));

    if (!fullName) return null;

    return <>{fullName}</>;
};
